<template >
    <div>
        <h1> Page Not Found </h1>
        <h5> Redirecting you to Home Page in {{remainingTime}} secs</h5> 
    </div>
</template>

<script>
	export default {
        name: "PageNotFound",
        data: function(){
            return {
                remainingTime: 3,
            }
        },
        mounted: function(){
            setInterval(() => {
                this.remainingTime = this.remainingTime - 1
            },1000);
            setTimeout(() => { 
                this.$router.push({
                    name: "Home"
                });
             }, 3000);
        }
    }
</script>

<style>
    body {
        height: 100vh;
        overflow-y: hidden;
        background-color: #ffffff;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>